module.exports = "<span title=\"{{$ctrl.text}}\">{{$ctrl.text}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/social-security.module/components/socialSecurityCard/socialSecurityData/socialSecurityData.html
// module id = 2301
// module chunks = 0